import React from 'react'

const PermissionDenied = () => {
  return (
    <div>You do not have the permissions to access this page. Please contact your Admin</div>
  )
}

export default PermissionDenied